import { initializeApp } from 'firebase/app';

import { getAuth, signOut, signInWithEmailAndPassword } from 'firebase/auth';

import {
  getFirestore,
  collection,
  getDocs,
  updateDoc,
  addDoc,
  serverTimestamp,
  query,
  where,
  doc,
  deleteDoc,
  runTransaction,
  setDoc,
  getDoc,
} from 'firebase/firestore';

const FileDownload = require('js-file-download');

const axios = require('axios');

if (!process.env.REACT_APP_SERVER_API_URL)
  throw new Error(
    'Undefined REACT_APP_SERVER_API_URL, got: ' + process.env.REACT_APP_SERVER_API_URL,
  );

if (!process.env.REACT_APP_PROJECT_ID)
  throw new Error('Undefined REACT_APP_PROJECT_ID, got: ' + process.env.REACT_APP_PROJECT_ID);

const url = process.env.REACT_APP_SERVER_API_URL;
const firebaseConfig = require(`./config/${process.env.REACT_APP_PROJECT_ID}.json`);
const storageBucket = firebaseConfig.storageBucket;

// Authentication instance
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// realtimedata
export const db = getFirestore(app);

export async function login(email, password) {
  try {
    const res = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: res.user };
  } catch (e) {
    return { success: false, message: e.code };
  }
}

export async function logout() {
  try {
    await signOut(auth);
  } catch (e) {
    console.log(e);
  }
}

// TODO - WARNING SICUREZZA - (al momento la ui non permette a chi non e' loggato queste operazioni ma le chiamate http non sono protette)

export async function download(from, to) {
  try {
    const response = await axios({
      timeout: 180000, // 3 minuti
      url: url + "/download",
      method: "GET",
      responseType: "blob", // Importante per file binari
      params: { from, to },
    });

    const fromStr = `${from.getFullYear()}-${from.getMonth() + 1}-${from.getDate()}`;
    const toStr = `${to.getFullYear()}-${to.getMonth() + 1}-${to.getDate()}`;
    const fileName = `ordini_da_${fromStr}_a_${toStr}.csv`;

    FileDownload(response.data, fileName);
    // console.log(`File salvato come: ${fileName}`);
  } catch (error) {
    console.error("Download fallito:", error);
    if (error.code === "ECONNABORTED") {
      console.error("❌ Download timeout! Prova ad aumentare il timeout.");
    }
  }
}

export async function makeOrder(products, combos, selectedDate, voucher) {
  const response = await axios.post(url + '/create-checkout-session', {
    products,
    combos,
    selectedDate,
    voucher,
  });
  return response.data.url;
}

// TODO MAKE IT SECURE!!! ONLY CASHIER
export async function makeOrderAsCashier(products, combos, selectedDate, paymentType, clientTotal) {


  const user = auth.currentUser;
  if (!user) {
    return { success: false, error: 'Utente non autenticato' };
  }

  // Permetti anche agli admin se abilitati da appSettings.adminCashier
  const settings = await getAppSettings();
  const adminCashierEnabled = !!settings?.adminCashier;
  const isCashier = user.displayName === 'cashier';
  const isAdminAsCashier = user.displayName === 'admin' && adminCashierEnabled;

  if (!isCashier && !isAdminAsCashier) {
    return {
      success: false,
      error: 'Accesso negato: solo i cashier (o admin con modalità cassa abilitata) possono effettuare ordini',
    };
  }


  const response = await axios.post(url + '/make-order-as-cashier', {
    products,
    combos,
    selectedDate,
    paymentType,
    clientTotal, // server per fare un check server side sul totale
    cashierEmail: user.email
  });
  return response.data;
}

export async function cancelOrder(orderId) {
  const response = await axios.post(url + '/cancel-order', { orderId });
  return response.data.success;
}

// E) aggiungere orderId se volessi supportare anche rimborso cashier
export async function refundOrder(paymentId, orderId) {
  const response = await axios.post(url + '/refund-order', { paymentId, orderId });
  return response.data;
}

// B) aggiungere orderId se volessi supportare anche rimborso cashier
export async function getPaymentAmount(paymentId, orderId) {
  const response = await axios.get(url + '/get-payment-amount', { params: { paymentId, orderId } });
  return response.data;
}

export async function getOrder(orderId) {
  const response = await axios.get(url + '/get-order', { params: { orderId } });
  return response.data.order;
}

// Alternativa a chiamare routes sul server = > Qui chiamo direttamente il DB
let settingsCache;
export async function getAppSettings() {
  if (settingsCache) return settingsCache;
  const querySnapshot = await getDocs(collection(db, 'app_setting'));
  let documents = [];
  querySnapshot.forEach((doc) => {
    let id = doc.id;
    let data = doc.data();
    data.eventDates = data.eventDates.map((item) => {
      return { date: item.date.toDate(), status: item.status };
    });
    settingsCache = { id, ...data };
    documents.push(settingsCache);
  });
  // C'e' solo un oggetto nella collection
  return documents[0];
}
export async function updateStatusForDate(date, status) {
  const allowedStatusValues = ['open', 'closed', 'priority'];
  if (!allowedStatusValues.includes(status)) {
    console.error('VALORE NON VALIDO PER DATE STATUS.', status);
    return;
  }

  const querySnapshot = await getDocs(collection(db, 'app_setting'));
  const doc = querySnapshot.docs[0];
  const eventDates = doc.data().eventDates;

  const dateIndex = eventDates.findIndex((item) => item.date.toDate().valueOf() === date.valueOf());

  if (dateIndex !== -1) {
    // Creare una nuova copia dell'array aggiornando solo lo stato della data specifica
    const updatedEventDates = [...eventDates];
    updatedEventDates[dateIndex] = { ...updatedEventDates[dateIndex], status: status };

    await updateDoc(doc.ref, {
      eventDates: updatedEventDates,
    });
    return;
  }
  // return new Error('Data non trovata')
}

export async function getMenu(onProgress) {
  const response = await axios.get(url + '/get-menu', {
    onDownloadProgress: function (progressEvent) {
      const percentage = progressEvent.total
        ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
        : '';
      onProgress(percentage);
    },
  });
  return response.data.menu;
}

// TODO MAKE IT SECURE!!! ONLY OPERATOR
export async function settleItem(orderId, itemId, amountToDeliver, userEmail) {
  const response = await axios.post(url + '/settle-item', {
    orderId,
    itemId,
    amountToDeliver,
    userEmail,
  });
  return response.data;
}

// TODO MAKE IT SECURE!!! ONLY ADMIN
export async function setItemAvailability(itemId, isProduct, isAvailable) {
  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : null;
  const response = await axios.post(
    url + '/set-item-availability',
    {
      itemId,
      isProduct,
      isAvailable,
    },
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
  );
  return response.data;
}

// TODO MAKE IT SECURE!!! ONLY ADMIN
export async function setItemMaxQuantity(itemId, quantity, refDate) {
  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : null;
  const response = await axios.post(
    url + '/set-item-max-quantity',
    {
      itemId,
      quantity,
      refDate,
    },
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
  );
  return response.data;
}

export async function uploadProductImage(file, productId, previousImageId) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Utente non autenticato');
  }
  const token = await user.getIdToken();
  const formData = new FormData();
  formData.append('image', file);
  formData.append('itemId', productId);
  formData.append('type', 'product');
  if (previousImageId) {
    formData.append('previousImageId', previousImageId);
  }

  try {
    const response = await axios.post(url + '/admin/upload-product-image', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.data?.success) {
      throw new Error(response.data?.error || 'Errore nel caricamento immagine prodotto');
    }
    return response.data;
  } catch (e) {
    throw new Error(e?.response?.data?.error || e.message || 'Errore nel caricamento immagine prodotto');
  }
}

export async function uploadComboImage(file, comboId, previousImageId) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Utente non autenticato');
  }
  const token = await user.getIdToken();
  const formData = new FormData();
  formData.append('image', file);
  formData.append('itemId', comboId);
  formData.append('type', 'combo');
  if (previousImageId) {
    formData.append('previousImageId', previousImageId);
  }

  try {
    const response = await axios.post(url + '/admin/upload-combo-image', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.data?.success) {
      throw new Error(response.data?.error || 'Errore nel caricamento immagine combo');
    }
    return response.data;
  } catch (e) {
    throw new Error(e?.response?.data?.error || e.message || 'Errore nel caricamento immagine combo');
  }
}

export async function ordersByEmail(email) {
  const response = await axios.get(url + '/orders-by-email', {
    params: { email },
  });
  return response.data;
}

export async function sendEmailOrder(orderId) {
  const response = await axios.post(url + '/send-email-order', {
    orderId,
  });
  return response.data;
}

const generateRandomCode = () => {
  const allowedChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const codeLength = 5;
  return Array.from(
    { length: codeLength },
    () => allowedChars[Math.floor(Math.random() * allowedChars.length)],
  ).join('');
};

// const calculateExpirationDate = () => {
//   // Calculate expiration date as 30 days from the current date
//   const currentDate = new Date();
//   const expirationDate = new Date(currentDate);
//   expirationDate.setDate(currentDate.getDate() + 30);
//   return expirationDate;
// };

export async function createVoucher(voucher, quantity, expirationDate) {
  try {
    const batch = [];

    for (let i = 0; i < quantity; i++) {
      const code = generateRandomCode();
      // const expirationDate = calculateExpirationDate();

      // console.log('voucher', voucher, expirationDate)
      const newVoucher = {
        value: voucher.value.v, // valori presi da Voucher.js
        type: voucher.value.type, // valori presi da Voucher.js
        code,
        // expirationDate: new Date(voucher.expirationDate),
        expirationDate: expirationDate,
        createdAt: serverTimestamp(),
        status: 'ready', // ready | depleted | se è scaduto si vede dalla data, altrimenti serve un cron?
      };

      batch.push(newVoucher);
    }

    const vouchersCollection = collection(db, 'voucher');
    await Promise.all(batch.map(async (voucher) => addDoc(vouchersCollection, voucher)));
    return { success: true, data: batch };
  } catch (error) {
    console.error('Error creating vouchers:', error);
    return { success: false, error: error.message };
  }
}

export async function getVoucher(code) {
  try {
    const vouchersCollection = collection(db, 'voucher');
    const q = query(vouchersCollection, where('code', '==', code));

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty)
      return { success: false, error: 'Nessun voucher trovato con codice ' + code };

    const voucher = querySnapshot.docs[0].data();
    return { success: true, data: voucher };
  } catch (error) {
    console.log('ERROR', error);
    return { success: false, error: error.message };
  }
}
export async function checkVoucher(code) {
  try {
    const res = await getVoucher(code);

    if (!res.success) return res;

    const voucher = res.data;

    voucher.createdAt = voucher.createdAt.toDate();
    voucher.expirationDate = voucher.expirationDate.toDate();

    if (voucher.status === 'depleted')
      return { success: false, error: 'Il voucher è stato utilizzato.' };
    if (new Date() > voucher.expirationDate)
      return { success: false, error: 'Il voucher è scaduto.' };
    return { success: true, data: voucher };
  } catch (error) {
    console.log('ERROR', error);
    return { success: false, error: error.message };
  }
}

// =========================
// Warehouse API
// =========================

const WAREHOUSE_COLLECTION = 'warehouse';

const buildWarehouseAction = ({ user, type, delta, previousQuantity, newQuantity }) => {
  return {
    // Non possiamo usare serverTimestamp dentro un array, salviamo un Date client-side
    at: new Date(),
    userId: user?.uid || null,
    userEmail: user?.email || null,
    type,
    delta,
    previousQuantity,
    newQuantity,
  };
};

export async function getWarehouseItems() {
  const snapshot = await getDocs(collection(db, WAREHOUSE_COLLECTION));
  const items = [];
  snapshot.forEach((docSnap) => {
    const data = docSnap.data();
    const history = Array.isArray(data.history) ? data.history : [];
    items.push({
      id: docSnap.id,
      ...data,
      createdAt: data.createdAt ? data.createdAt.toDate() : null,
      updatedAt: data.updatedAt ? data.updatedAt.toDate() : null,
      history: history.map((h) => {
        let at = null;
        if (h.at instanceof Date) {
          at = h.at;
        } else if (h.at && typeof h.at.toDate === 'function') {
          at = h.at.toDate();
        } else if (typeof h.at === 'number') {
          at = new Date(h.at);
        }
        return { ...h, at };
      }),
    });
  });
  // Ordina per nome per coerenza
  items.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  return items;
}

export async function createWarehouseItem({ name, quantity, minQuantity }) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Utente non autenticato');
  }

  const initialQuantity = Number.isFinite(quantity) ? quantity : 0;
  const minQ = Number.isFinite(minQuantity) ? minQuantity : 0;

  const action = buildWarehouseAction({
    user,
    type: 'create',
    delta: initialQuantity,
    previousQuantity: 0,
    newQuantity: initialQuantity,
  });

  const ref = collection(db, WAREHOUSE_COLLECTION);
  await addDoc(ref, {
    name,
    quantity: initialQuantity,
    minQuantity: minQ,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    history: [action],
  });
}

async function updateWarehouseItemWithHistory(
  id,
  { quantityDelta = 0, name, minQuantity },
  { actionType },
) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Utente non autenticato');
  }

  const docRef = doc(db, WAREHOUSE_COLLECTION, id);

  const result = await runTransaction(db, async (transaction) => {
    const snap = await transaction.get(docRef);
    if (!snap.exists()) {
      throw new Error('Documento non trovato');
    }
    const data = snap.data();
    const prevQuantity = Number.isFinite(data.quantity) ? data.quantity : 0;
    const minQ = Number.isFinite(data.minQuantity) ? data.minQuantity : 0;

    const delta = Number.isFinite(quantityDelta) ? quantityDelta : 0;
    const newQuantity = prevQuantity + delta;
    if (newQuantity < 0) {
      throw new Error('La quantità non può essere negativa');
    }

    const history = Array.isArray(data.history) ? data.history : [];
    const action = buildWarehouseAction({
      user,
      type: actionType,
      delta,
      previousQuantity: prevQuantity,
      newQuantity,
    });
    const newHistory = [action, ...history].slice(0, 30);

    const crossedBelowMin = prevQuantity >= minQ && newQuantity < minQ;

    transaction.update(docRef, {
      name: name !== undefined ? name : data.name,
      minQuantity: minQuantity !== undefined ? minQuantity : data.minQuantity,
      quantity: newQuantity,
      updatedAt: serverTimestamp(),
      history: newHistory,
    });

    return {
      crossedBelowMin,
      name: name !== undefined ? name : data.name,
      newQuantity,
      minQuantity: minQ,
    };
  });

  return result;
}

export async function updateWarehouseItemQuantity(id, delta) {
  const actionType = delta >= 0 ? 'add' : 'remove';
  return updateWarehouseItemWithHistory(
    id,
    {
      quantityDelta: delta,
    },
    { actionType },
  );
}

export async function renameWarehouseItem(id, newName) {
  return updateWarehouseItemWithHistory(
    id,
    {
      quantityDelta: 0,
      name: newName,
    },
    { actionType: 'rename' },
  );
}

export async function updateWarehouseMinQuantity(id, minQuantity) {
  return updateWarehouseItemWithHistory(
    id,
    {
      quantityDelta: 0,
      minQuantity,
    },
    { actionType: 'updateMinQuantity' },
  );
}

export async function deleteWarehouseItem(id) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Utente non autenticato');
  }
  const ref = doc(db, WAREHOUSE_COLLECTION, id);
  await deleteDoc(ref);
}

export async function sendWarehouseLowStockEmail(productName, currentQuantity, minQuantity, testEmail = null) {
  const response = await axios.post(url + '/send-warehouse-low-stock-email', {
    productName,
    currentQuantity,
    minQuantity,
    testEmail,
  });
  return response.data;
}

// =========================
// Menu Admin - Products & Combos
// =========================

const PRODUCT_COLLECTION = 'product';
const COMBO_COLLECTION = 'combo';
const MENU_COLLECTION = 'menu';
const MENU_ID = 'menu-1';

export async function getAllProducts() {
  const snapshot = await getDocs(collection(db, PRODUCT_COLLECTION));
  const products = [];
  snapshot.forEach((docSnap) => {
    products.push({ id: docSnap.id, ...docSnap.data() });
  });
  // Ordina per posizione, poi per titolo
  products.sort((a, b) => {
    const posA = Number.isFinite(a.position) ? a.position : 0;
    const posB = Number.isFinite(b.position) ? b.position : 0;
    if (posA !== posB) return posA - posB;
    return (a.title || '').localeCompare(b.title || '');
  });
  return products;
}

const buildQuantitiesForProduct = (product, appSettings) => {
  const maxQ = Number.parseInt(product.maxQuantity);
  if (!appSettings || appSettings.skipDate) {
    return maxQ;
  }
  const dates = appSettings.eventDates || [];
  return dates.map((item) => ({
    date: item.date,
    qty: maxQ,
  }));
};

const buildDiscountFromInput = (input) => {
  const everyRaw = input.discountEvery;
  const getRaw = input.discountGet;
  const fromRaw = input.discountFrom;
  const toRaw = input.discountTo;

  if (everyRaw === undefined && getRaw === undefined && !fromRaw && !toRaw) {
    return null;
  }

  const every = Number(everyRaw);
  const get = Number(getRaw);
  if (!Number.isFinite(every) || every <= 0) return null;
  if (!Number.isFinite(get) || get <= every) return null;
  if (!fromRaw || !toRaw) return null;

  const from =
    fromRaw instanceof Date ? fromRaw : typeof fromRaw === 'string' ? new Date(fromRaw) : null;
  const to =
    toRaw instanceof Date ? toRaw : typeof toRaw === 'string' ? new Date(toRaw) : null;
  if (!from || !to || Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return null;

  return {
    every,
    get,
    from,
    to,
  };
};

export async function createProductAdmin(productInput) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono creare prodotti');
  }

  const appSettings = await getAppSettings();
  const id = productInput.id;
  if (!id) {
    throw new Error('ID prodotto obbligatorio');
  }

  const docRef = doc(db, PRODUCT_COLLECTION, id);
  const existing = await getDoc(docRef);
  if (existing.exists()) {
    throw new Error('Esiste già un prodotto con questo ID');
  }

   // Calcola la posizione come ultima nella sua categoria
  const category = productInput.category || '';
  let newPosition = Date.now();
  try {
    const productsRef = collection(db, PRODUCT_COLLECTION);
    const q = query(productsRef, where('category', '==', category));
    const snapshot = await getDocs(q);
    let maxPos = 0;
    snapshot.forEach((docSnap) => {
      const data = docSnap.data();
      const pos = Number.isFinite(data.position) ? data.position : 0;
      if (pos > maxPos) maxPos = pos;
    });
    newPosition = maxPos + 1;
  } catch (e) {
    // In caso di errore, manteniamo Date.now() come fallback
    newPosition = Date.now();
  }

  const quantities = buildQuantitiesForProduct(productInput, appSettings);
  const discount = buildDiscountFromInput(productInput);

  const product = {
    category: productInput.category || '',
    id,
    title: productInput.title || '',
    description: productInput.description || '',
    descriptionShort: productInput.descriptionShort || '',
    price: String(productInput.price || ''),
    maxQuantity: String(productInput.maxQuantity || ''),
    vat: productInput.vat !== undefined ? Number(productInput.vat) : 10,
    extra: productInput.extra || '',
    discount: discount,
    meta: productInput.meta || null,
    imageId: productInput.imageId || '',
    isAvailable: true,
    position: newPosition,
    quantities,
  };

  await setDoc(docRef, product);

  // Aggiorna il documento di menu per includere il nuovo prodotto
  const menuRef = doc(db, MENU_COLLECTION, MENU_ID);
  const menuSnap = await getDoc(menuRef);
  if (menuSnap.exists()) {
    const data = menuSnap.data();
    const currentProducts = Array.isArray(data.products) ? data.products : [];
    if (!currentProducts.includes(id)) {
      await updateDoc(menuRef, {
        products: [...currentProducts, id],
      });
    }
  } else {
    await setDoc(menuRef, { products: [id] }, { merge: true });
  }
}

export async function updateProductAdmin(id, update) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono modificare prodotti');
  }

  const docRef = doc(db, PRODUCT_COLLECTION, id);
  const snap = await getDoc(docRef);
  if (!snap.exists()) {
    throw new Error('Prodotto non trovato');
  }

  const current = snap.data();
  const payload = {
    ...update,
  };

  // Non toccare quantities qui: verranno gestite dall’editor date
  delete payload.quantities;

  // Normalizza alcuni campi se presenti
  if (payload.price !== undefined) {
    payload.price = String(payload.price);
  }
  if (payload.maxQuantity !== undefined) {
    payload.maxQuantity = String(payload.maxQuantity);
  }
  if (payload.vat !== undefined) {
    payload.vat = Number(payload.vat);
  }

  const discount = buildDiscountFromInput(update);
  if (
    'discountEvery' in update ||
    'discountGet' in update ||
    'discountFrom' in update ||
    'discountTo' in update
  ) {
    payload.discount = discount;
  }
  delete payload.discountEvery;
  delete payload.discountGet;
  delete payload.discountFrom;
  delete payload.discountTo;

  await updateDoc(docRef, payload);

  // Gestione eventuale cambio ID non supportata qui (richiede logica più complessa)
  return { ...current, ...payload };
}

export async function deleteProductAdmin(id) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono eliminare prodotti');
  }

  const productRef = doc(db, PRODUCT_COLLECTION, id);
  await deleteDoc(productRef);

  // Aggiorna il documento di menu rimuovendo il prodotto
  const menuRef = doc(db, MENU_COLLECTION, MENU_ID);
  const menuSnap = await getDoc(menuRef);
  if (menuSnap.exists()) {
    const data = menuSnap.data();
    const currentProducts = Array.isArray(data.products) ? data.products : [];
    const nextProducts = currentProducts.filter((pId) => pId !== id);
    await updateDoc(menuRef, { products: nextProducts });
  }

  // Rimuovi il prodotto da tutte le combo che lo contengono
  const combosSnap = await getDocs(collection(db, COMBO_COLLECTION));
  const updates = [];
  combosSnap.forEach((comboDoc) => {
    const data = comboDoc.data();
    const products = Array.isArray(data.products) ? data.products : [];
    if (products.includes(id)) {
      const next = products.filter((pId) => pId !== id);
      updates.push(
        updateDoc(comboDoc.ref, {
          products: next,
          // Se una combo resta vuota, la rendiamo non disponibile
          isAvailable: next.length === 0 ? false : data.isAvailable,
        }),
      );
    }
  });
  if (updates.length) {
    await Promise.all(updates);
  }
}

export async function getAllCombos() {
  const snapshot = await getDocs(collection(db, COMBO_COLLECTION));
  const combos = [];
  snapshot.forEach((docSnap) => {
    combos.push({ id: docSnap.id, ...docSnap.data() });
  });
  combos.sort((a, b) => {
    const posA = Number.isFinite(a.position) ? a.position : 0;
    const posB = Number.isFinite(b.position) ? b.position : 0;
    if (posA !== posB) return posA - posB;
    return (a.title || '').localeCompare(b.title || '');
  });
  return combos;
}

export async function createComboAdmin(comboInput) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono creare combo');
  }

  const id = comboInput.id;
  if (!id) throw new Error('ID combo obbligatorio');

  const comboRef = doc(db, COMBO_COLLECTION, id);
  const existing = await getDoc(comboRef);
  if (existing.exists()) {
    throw new Error('Esiste già una combo con questo ID');
  }

  const products = Array.isArray(comboInput.products) ? comboInput.products : [];
  if (products.length === 0) {
    throw new Error('Una combo deve contenere almeno un prodotto');
  }

  // Validazione: i prodotti referenziati devono esistere
  const allProducts = await getAllProducts();
  const productIds = new Set(allProducts.map((p) => p.id));
  const invalid = products.filter((pId) => !productIds.has(pId));
  if (invalid.length) {
    throw new Error('Prodotti non validi nella combo: ' + invalid.join(', '));
  }

  const discount = buildDiscountFromInput(comboInput);

  // Calcola la posizione come ultima tra le combo
  let newPosition = Date.now();
  try {
    const combosSnap = await getDocs(collection(db, COMBO_COLLECTION));
    let maxPos = 0;
    combosSnap.forEach((docSnap) => {
      const data = docSnap.data();
      const pos = Number.isFinite(data.position) ? data.position : 0;
      if (pos > maxPos) maxPos = pos;
    });
    newPosition = maxPos + 1;
  } catch (e) {
    newPosition = Date.now();
  }

  const combo = {
    id,
    title: comboInput.title || '',
    description: comboInput.description || '',
    price: String(comboInput.price || ''),
    vat: comboInput.vat !== undefined ? Number(comboInput.vat) : 10,
    discount: discount,
    products,
    imageId: comboInput.imageId || '',
    isAvailable: true,
    position: newPosition,
  };

  await setDoc(comboRef, combo);

  // Aggiorna menu doc includendo la combo
  const menuRef = doc(db, MENU_COLLECTION, MENU_ID);
  const menuSnap = await getDoc(menuRef);
  if (menuSnap.exists()) {
    const data = menuSnap.data();
    const currentCombos = Array.isArray(data.combos) ? data.combos : [];
    if (!currentCombos.includes(id)) {
      await updateDoc(menuRef, { combos: [...currentCombos, id] });
    }
  } else {
    await setDoc(menuRef, { combos: [id] }, { merge: true });
  }
}

export async function updateComboAdmin(id, update) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono modificare combo');
  }

  const comboRef = doc(db, COMBO_COLLECTION, id);
  const snap = await getDoc(comboRef);
  if (!snap.exists()) throw new Error('Combo non trovata');

  const payload = { ...update };

  if (payload.price !== undefined) payload.price = String(payload.price);
  if (payload.vat !== undefined) payload.vat = Number(payload.vat);

  const discount = buildDiscountFromInput(update);
  if (
    'discountEvery' in update ||
    'discountGet' in update ||
    'discountFrom' in update ||
    'discountTo' in update
  ) {
    payload.discount = discount;
  }
  delete payload.discountEvery;
  delete payload.discountGet;
  delete payload.discountFrom;
  delete payload.discountTo;

  if (payload.products) {
    const products = Array.isArray(payload.products) ? payload.products : [];
    if (products.length === 0) {
      throw new Error('Una combo deve contenere almeno un prodotto');
    }
    const allProducts = await getAllProducts();
    const productIds = new Set(allProducts.map((p) => p.id));
    const invalid = products.filter((pId) => !productIds.has(pId));
    if (invalid.length) {
      throw new Error('Prodotti non validi nella combo: ' + invalid.join(', '));
    }
  }

  await updateDoc(comboRef, payload);
  return { ...snap.data(), ...payload };
}

export async function deleteComboAdmin(id) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono eliminare combo');
  }

  const comboRef = doc(db, COMBO_COLLECTION, id);
  await deleteDoc(comboRef);

  // Aggiorna menu doc rimuovendo la combo
  const menuRef = doc(db, MENU_COLLECTION, MENU_ID);
  const menuSnap = await getDoc(menuRef);
  if (menuSnap.exists()) {
    const data = menuSnap.data();
    const currentCombos = Array.isArray(data.combos) ? data.combos : [];
    const nextCombos = currentCombos.filter((cId) => cId !== id);
    await updateDoc(menuRef, { combos: nextCombos });
  }
}

export async function saveEventDatesAdmin(eventDates) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Utente non autenticato');
  }
  if (user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono modificare le date evento');
  }

  const token = await user.getIdToken();
  const response = await axios.post(
    url + '/admin/save-event-dates',
    { eventDates },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  if (!response.data?.success) {
    throw new Error(response.data?.error || 'Errore nel salvataggio delle date');
  }
  // Invalida cache settings per rileggerle aggiornate
  settingsCache = undefined;
  return response.data;
}

export async function updateProductPositionsAdmin(orderedIds) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono riordinare prodotti');
  }
  if (!Array.isArray(orderedIds)) return;

  const updates = orderedIds.map((id, idx) => {
    const ref = doc(db, PRODUCT_COLLECTION, id);
    return updateDoc(ref, { position: idx });
  });
  await Promise.all(updates);
}

export async function updateComboPositionsAdmin(orderedIds) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono riordinare combo');
  }
  if (!Array.isArray(orderedIds)) return;

  const updates = orderedIds.map((id, idx) => {
    const ref = doc(db, COMBO_COLLECTION, id);
    return updateDoc(ref, { position: idx });
  });
  await Promise.all(updates);
}

export async function duplicateProductAdmin(product) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono duplicare prodotti');
  }
  const generateRandomItemId = () => {
    return Math.random().toString(36).slice(2, 12);
  };
  const baseId = product.id || 'product';
  const newId = generateRandomItemId();
  const basePosition = Number.isFinite(product.position) ? product.position : Date.now();
  const copy = {
    ...product,
    id: newId,
    title: `Copia di ${product.title || baseId}`,
    isAvailable: true,
    position: basePosition + 0.1,
  };
  const ref = doc(db, PRODUCT_COLLECTION, newId);
  await setDoc(ref, copy);

  const menuRef = doc(db, MENU_COLLECTION, MENU_ID);
  const menuSnap = await getDoc(menuRef);
  const current = menuSnap.exists() ? menuSnap.data() : {};
  const currentProducts = Array.isArray(current.products) ? current.products : [];
  if (!currentProducts.includes(newId)) {
    if (menuSnap.exists()) {
      await updateDoc(menuRef, { products: [...currentProducts, newId] });
    } else {
      await setDoc(menuRef, { products: [newId] }, { merge: true });
    }
  }
  return newId;
}

export async function duplicateComboAdmin(combo) {
  const user = auth.currentUser;
  if (!user || user.displayName !== 'admin') {
    throw new Error('Accesso negato: solo gli admin possono duplicare combo');
  }
  const generateRandomItemId = () => {
    return Math.random().toString(36).slice(2, 12);
  };
  const baseId = combo.id || 'combo';
  const newId = generateRandomItemId();
  const basePosition = Number.isFinite(combo.position) ? combo.position : Date.now();
  const copy = {
    ...combo,
    id: newId,
    title: `Copia di ${combo.title || baseId}`,
    isAvailable: true,
    position: basePosition + 0.1,
    products: Array.isArray(combo.products) ? combo.products : [],
  };
  const ref = doc(db, COMBO_COLLECTION, newId);
  await setDoc(ref, copy);

  const menuRef = doc(db, MENU_COLLECTION, MENU_ID);
  const menuSnap = await getDoc(menuRef);
  const current = menuSnap.exists() ? menuSnap.data() : {};
  const currentCombos = Array.isArray(current.combos) ? current.combos : [];
  if (!currentCombos.includes(newId)) {
    if (menuSnap.exists()) {
      await updateDoc(menuRef, { combos: [...currentCombos, newId] });
    } else {
      await setDoc(menuRef, { combos: [newId] }, { merge: true });
    }
  }
  return newId;
}

export async function getUsers() {
  const user = auth.currentUser;
  if (!user) {
    return { success: false, error: 'Utente non autenticato' };
  }

  if (user.displayName !== 'admin') {
    return { success: false, error: 'Accesso negato: solo gli admin possono visualizzare gli utenti' };
  }

  try {
    const token = await user.getIdToken();
    const response = await axios.get(url + '/get-users', {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return { success: false, error: error.message };
  }
}

export async function updateUserDisplayName(uid, displayName) {
  const user = auth.currentUser;
  if (!user) {
    return { success: false, error: 'Utente non autenticato' };
  }

  if (user.displayName !== 'admin') {
    return { success: false, error: 'Accesso negato: solo gli admin possono modificare gli utenti' };
  }

  try {
    const token = await user.getIdToken();
    const response = await axios.post(url + '/update-user-displayName', {
      uid,
      displayName,
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user displayName:', error);
    return { success: false, error: error.response?.data?.error || error.message };
  }
}

export async function createUser(email, password, displayName) {
  const user = auth.currentUser;
  if (!user) {
    return { success: false, error: 'Utente non autenticato' };
  }

  if (user.displayName !== 'admin') {
    return { success: false, error: 'Accesso negato: solo gli admin possono creare utenti' };
  }

  try {
    const token = await user.getIdToken();
    const response = await axios.post(url + '/create-user', {
      email,
      password,
      displayName,
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    return { success: false, error: error.response?.data?.error || error.message };
  }
}

export async function deleteUser(uid) {
  const user = auth.currentUser;
  if (!user) {
    return { success: false, error: 'Utente non autenticato' };
  }

  if (user.displayName !== 'admin') {
    return { success: false, error: 'Accesso negato: solo gli admin possono eliminare utenti' };
  }

  try {
    const token = await user.getIdToken();
    const response = await axios.post(url + '/delete-user', {
      uid,
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting user:', error);
    return { success: false, error: error.response?.data?.error || error.message };
  }
}
